var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("BusinessPurchaseApply.dataForm.title")) + " "
          ),
        ]
      ),
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          [
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseComponentsPur.code"),
                      prop: "code",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        disabled: "",
                        placeholder: _vm.$t(
                          "BusinessPurchaseComponentsPur.automatic"
                        ),
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                      },
                      model: {
                        value: _vm.form.purchaseCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "purchaseCode", $$v)
                        },
                        expression: "form.purchaseCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.supplierCode"
                      ),
                      prop: "supplierCode",
                    },
                  },
                  [
                    _c("BjSelectSupplier", {
                      attrs: {
                        "option-value": "code",
                        "page-size": 100,
                        "default-options": {
                          label: _vm.form.supplierName,
                          value: _vm.form.supplierCode,
                        },
                        disabled: _vm.isEdit,
                      },
                      on: { change: _vm.onChangeSupplier },
                      model: {
                        value: _vm.form.supplierCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierCode", $$v)
                        },
                        expression: "form.supplierCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseComponentsPur.type"),
                      disabled: _vm.isEdit,
                      prop: "purchaseType",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        disabled: _vm.isEdit,
                        "option-list": _vm.PURCHASE_TYPE,
                      },
                      on: { change: _vm.changeLov },
                      model: {
                        value: _vm.form.purchaseType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "purchaseType", $$v)
                        },
                        expression: "form.purchaseType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.warehouseCode"
                      ),
                      prop: "warehouseCode",
                    },
                  },
                  [
                    _c("BjSelectWarehouse", {
                      attrs: { "value-code": "code", "type-code": ["logic"] },
                      on: { change: _vm.onChangeWarehouse },
                      model: {
                        value: _vm.form.warehouseCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "warehouseCode", $$v)
                        },
                        expression: "form.warehouseCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _vm.isEdit
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseComponentsPur.buyerName"
                          ),
                          prop: "buyerName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT },
                          model: {
                            value: _vm.form.createdName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "createdName", $$v)
                            },
                            expression: "form.createdName",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("BusinessPurchaseApply.isFill") } },
                  [
                    _c("BjSelectLov", {
                      attrs: { "option-list": _vm.STATUS_YES_NUM },
                      model: {
                        value: _vm.form.isFill,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isFill", $$v)
                        },
                        expression: "form.isFill",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.postingDate"
                      ),
                      prop: "postingDate",
                    },
                  },
                  [
                    _c("BjDatePicker", {
                      model: {
                        value: _vm.form.postingDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "postingDate", $$v)
                        },
                        expression: "form.postingDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.documentDate"
                      ),
                      prop: "documentDate",
                    },
                  },
                  [
                    _c("BjDatePicker", {
                      model: {
                        value: _vm.form.documentDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "documentDate", $$v)
                        },
                        expression: "form.documentDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseComponentsPur.remark"),
                      prop: "remark",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        autosize: "",
                        type: "textarea",
                        placeholder: _vm.$t("inputText"),
                      },
                      model: {
                        value: _vm.form.remarks,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remarks", $$v)
                        },
                        expression: "form.remarks",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _c(
            "BjDivider",
            {
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c("RightToolbar", {
                        on: { showSetting: _vm.toolbarShow },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("BusinessPurchaseComponentsPur.information")) +
                  " "
              ),
              [
                _vm.list.length === 0
                  ? _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessPurchaseComponentsPur.addingGoods")
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.form.purchaseType !== "COMMON"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onImport },
                      },
                      [_vm._v(_vm._s(_vm.$t("EXCELImportText")))]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { disabled: _vm.selection.length === 0 },
                    on: {
                      click: function ($event) {
                        return _vm.onDelete()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("delText")))]
                ),
              ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "bj-col bj-col-24",
              staticStyle: { "border-left": "none" },
            },
            [
              _vm.tableShow
                ? _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.form.goodsList,
                        border: "",
                        script: "",
                        "max-height": "600px",
                      },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "70",
                          align: "center",
                          fixed: "left",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuCode",
                          label: "SKU",
                          align: "center",
                          fixed: "left",
                          width: "133",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseApplyDetail.orderQty") +
                            " (a)",
                          prop: "planQty",
                          align: "center",
                          width: "140",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputNumber", {
                                    staticClass: "full-width",
                                    attrs: {
                                      min: 0,
                                      clearable: "",
                                      controls: false,
                                    },
                                    model: {
                                      value: row.planQty,
                                      callback: function ($$v) {
                                        _vm.$set(row, "planQty", $$v)
                                      },
                                      expression: "row.planQty",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          534634041
                        ),
                      }),
                      _vm.$route.query.source === "forecast"
                        ? _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.$t("BusinessPurchaseApply.planQty") +
                                " (b)",
                              prop: "alreadyQty",
                              align: "center",
                              width: "150",
                            },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseApply.cnPurchasePrice") +
                            " (c)",
                          prop: "cnPurchasePrice",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputMoney", {
                                    staticClass: "full-width",
                                    attrs: {
                                      min: 0,
                                      controls: false,
                                      clearable: false,
                                    },
                                    model: {
                                      value: row.cnPurchasePrice,
                                      callback: function ($$v) {
                                        _vm.$set(row, "cnPurchasePrice", $$v)
                                      },
                                      expression: "row.cnPurchasePrice",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2476254355
                        ),
                      }),
                      _vm.sortableSetting.auPurchasePrice
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "BusinessPurchaseDetailPage.table.Australian"
                                  ) + " (d)",
                                prop: "auPurchasePrice",
                                align: "center",
                                width: "170",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "auPurchasePrice",
                                  align: "center",
                                  label:
                                    "d = c * 1.02 / " +
                                    _vm.exchangeRate.aud.toFixed(2),
                                  width: "170",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.auPurchasePrice) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4055166765
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseApply.price") + " (e)",
                          prop: "price",
                          align: "center",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputMoney", {
                                    staticClass: "full-width",
                                    attrs: {
                                      min: 0,
                                      clearable: false,
                                      controls: false,
                                    },
                                    model: {
                                      value: row.price,
                                      callback: function ($$v) {
                                        _vm.$set(row, "price", $$v)
                                      },
                                      expression: "row.price",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          477787541
                        ),
                      }),
                      _vm.sortableSetting.linkUrl
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Link"
                              ),
                              prop: "linkUrl",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("BjInput", {
                                        staticClass: "full-width",
                                        attrs: {
                                          placeholder: _vm.$t("inputText"),
                                          min: 0,
                                          controls: false,
                                        },
                                        model: {
                                          value: row.linkUrl,
                                          callback: function ($$v) {
                                            _vm.$set(row, "linkUrl", $$v)
                                          },
                                          expression: "row.linkUrl",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1885536020
                            ),
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Price"
                          ),
                          prop: "linkMinPrice",
                          align: "center",
                          width: "140",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInput", {
                                    staticClass: "full-width",
                                    attrs: {
                                      placeholder: _vm.$t("inputText"),
                                      min: 0,
                                      clearable: "",
                                      controls: false,
                                    },
                                    model: {
                                      value: row.linkMinPrice,
                                      callback: function ($$v) {
                                        _vm.$set(row, "linkMinPrice", $$v)
                                      },
                                      expression: "row.linkMinPrice",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          30576157
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseDetailPage.table.Express") +
                            " (f)",
                          prop: "expressPrice",
                          align: "center",
                          width: "140",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputMoney", {
                                    staticClass: "full-width",
                                    attrs: { min: 0, controls: false },
                                    model: {
                                      value: row.expressPrice,
                                      callback: function ($$v) {
                                        _vm.$set(row, "expressPrice", $$v)
                                      },
                                      expression: "row.expressPrice",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3824192439
                        ),
                      }),
                      _vm.sortableSetting.consumptionTax
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "BusinessPurchaseDetailPage.table.Consumption"
                                  ) + " (g)",
                                prop: "consumptionTax",
                                align: "center",
                                width: "155",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "consumptionTax",
                                  align: "center",
                                  label: _vm.consumptionTaxHead,
                                  width: "155",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.consumptionTax) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2378277015
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.purchaseType !== "COMMON" &&
                      _vm.sortableSetting.platformPrice
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "BusinessPurchaseDetailPage.table.Platform"
                                  ) + " (h)",
                                prop: "platformPrice",
                                align: "center",
                                width: "140",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "platformPrice",
                                  align: "center",
                                  label: _vm.platformPriceHead,
                                  width: "140",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sortableSetting.taxCode
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "taxCode",
                              label: _vm.$t(
                                "BusinessPurchaseComponentsPur.table.TaxCode"
                              ),
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          model: {
                                            value: row.taxCode,
                                            callback: function ($$v) {
                                              _vm.$set(row, "taxCode", $$v)
                                            },
                                            expression: "row.taxCode",
                                          },
                                        },
                                        _vm._l(_vm.options, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              288123872
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.refundResendPrice
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label: "return+resend (j)",
                                align: "center",
                                width: "140",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "refundResendPrice",
                                  label: _vm.resendRefundRateHead,
                                  width: "140",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseApply.usdFreight") + " (k)",
                          prop: "usdFreight",
                          align: "center",
                          width: "118",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputMoney", {
                                    staticClass: "full-width",
                                    attrs: { min: 0, controls: false },
                                    model: {
                                      value: row.usdFreight,
                                      callback: function ($$v) {
                                        _vm.$set(row, "usdFreight", $$v)
                                      },
                                      expression: "row.usdFreight",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3078801953
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseApply.cnyFreight") + " (l)",
                          prop: "cnyFreight",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputMoney", {
                                    staticClass: "full-width",
                                    attrs: { min: 0, controls: false },
                                    model: {
                                      value: row.cnyFreight,
                                      callback: function ($$v) {
                                        _vm.$set(row, "cnyFreight", $$v)
                                      },
                                      expression: "row.cnyFreight",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3935181207
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseApply.handlePrice") +
                            " (m)",
                          prop: "handlePrice",
                          align: "center",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("BjInputMoney", {
                                    staticClass: "full-width",
                                    attrs: { min: 0, controls: false },
                                    model: {
                                      value: row.handlePrice,
                                      callback: function ($$v) {
                                        _vm.$set(row, "handlePrice", $$v)
                                      },
                                      expression: "row.handlePrice",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1147029959
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label:
                            _vm.$t("BusinessPurchaseApply.cabinetVolume") +
                            " (n)",
                          prop: "cabinetVolume",
                          align: "center",
                          width: "140",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "BjInputMoney",
                                    {
                                      staticClass: "full-width",
                                      attrs: { min: 0, controls: false },
                                      model: {
                                        value: row.cabinetVolume,
                                        callback: function ($$v) {
                                          _vm.$set(row, "cabinetVolume", $$v)
                                        },
                                        expression: "row.cabinetVolume",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("m³"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1613733473
                        ),
                      }),
                      _vm.sortableSetting.seaInlandFreight
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "BusinessPurchaseApply.seaInlandFreight"
                                  ) + " (o)",
                                prop: "seaInlandFreight",
                                align: "center",
                                width: "290",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "seaInlandFreight",
                                  label: _vm.seaAndInlandFreightHead,
                                  width: "290",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.seaInlandFreight !== "NaN"
                                                  ? row.seaInlandFreight
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2953486974
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sortableSetting.ebayPaypalPrice
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "BusinessPurchaseApply.ebayPaypalPrice"
                                  ) + " (p)",
                                align: "center",
                                width: "150",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  prop: "ebayPaypalPrice",
                                  label: _vm.ebayAndPaypalHead,
                                  width: "150",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sortableSetting.estimatedProfit
                        ? _c(
                            "el-table-column",
                            {
                              attrs: {
                                label:
                                  _vm.$t(
                                    "BusinessPurchaseDetailPage.table.Estimated"
                                  ) + " (q)",
                                prop: "estimatedProfit",
                                align: "center",
                                width: "160",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "estimatedProfit",
                                  align: "center",
                                  label: _vm.estimatedProfitHead,
                                  width: "160",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.estimatedProfit !== "NaN"
                                                  ? row.estimatedProfit
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  780976158
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.sortableSetting.estimatedProfitRate
                        ? _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.$t(
                                  "BusinessPurchaseDetailPage.table.Expected"
                                ) + " (r)",
                              prop: "estimatedProfitRate",
                              align: "center",
                              width: "130",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            row.estimatedProfitRate !== "NaN"
                                              ? row.estimatedProfitRate
                                              : ""
                                          ) +
                                          "% "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2829235899
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.requiredDate
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "requiredDate",
                              label: _vm.$t(
                                "BusinessPurchaseComponentsPur.requiredDate"
                              ),
                              align: "center",
                              width: "156",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("BjDatePicker", {
                                        model: {
                                          value: row.requiredDate,
                                          callback: function ($$v) {
                                            _vm.$set(row, "requiredDate", $$v)
                                          },
                                          expression: "row.requiredDate",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3057195838
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.barCode
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Barcode"
                              ),
                              prop: "barCode",
                              align: "center",
                              width: "120",
                            },
                          })
                        : _vm._e(),
                      _vm.sortableSetting.brandName
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.brand"
                              ),
                              prop: "brandName",
                              align: "center",
                              width: "120",
                            },
                          })
                        : _vm._e(),
                      _vm.sortableSetting.categoryName
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Product1"
                              ),
                              prop: "categoryName",
                              align: "center",
                              width: "145",
                            },
                          })
                        : _vm._e(),
                      _vm.sortableSetting.skuName
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Description"
                              ),
                              prop: "skuName",
                              align: "center",
                              width: "150",
                            },
                          })
                        : _vm._e(),
                      _vm.sortableSetting.length
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.length"
                              ),
                              prop: "length",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(" " + _vm._s(row.length) + " cm "),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2173930061
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.width
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.width"
                              ),
                              prop: "width",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(" " + _vm._s(row.width) + " cm "),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1998951927
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.height
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.high"
                              ),
                              prop: "height",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(" " + _vm._s(row.height) + " cm "),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1702596494
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.weight
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Weight"
                              ),
                              prop: "weight",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(" " + _vm._s(row.weight) + " kg "),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3475329875
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.volume
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Volume"
                              ),
                              prop: "volume",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (row.width *
                                              row.height *
                                              row.length) /
                                              1000000
                                          ) +
                                          " m³ "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              610487067
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.qty
                        ? _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.$t("BusinessPurchaseDetailPage.table.per") +
                                " (v)",
                              prop: "qty",
                              align: "center",
                              width: "120",
                            },
                          })
                        : _vm._e(),
                      _vm.sortableSetting.cartonLength
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.boxLength"
                              ),
                              prop: "cartonLength",
                              align: "center",
                              width: "110",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " + _vm._s(row.cartonLength) + " cm "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2743676360
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.cartonWidth
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.boxWidth"
                              ),
                              prop: "cartonWidth",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " + _vm._s(row.cartonWidth) + " cm "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1891811634
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.cartonHeight
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.boxheight"
                              ),
                              prop: "cartonHeight",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " + _vm._s(row.cartonHeight) + " cm "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              161951307
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.cartonWeight
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.boxWeight"
                              ),
                              prop: "cartonWeight",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " + _vm._s(row.cartonWeight) + " kg "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3295479382
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.cartonVolume
                        ? _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.$t(
                                  "BusinessPurchaseDetailPage.table.boxVolume"
                                ) + " (w)",
                              prop: "cartonVolume",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (row.cartonLength *
                                              row.cartonWidth *
                                              row.cartonHeight) /
                                              1000000
                                          ) +
                                          " m³ "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              524680542
                            ),
                          })
                        : _vm._e(),
                      _vm.sortableSetting.createdName
                        ? _c("el-table-column", {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseDetailPage.table.Buyer"
                              ),
                              prop: "createdName",
                              align: "center",
                              width: "110",
                            },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          prop: "",
                          label: _vm.$t("table.operationText"),
                          fixed: "right",
                          align: "center",
                          width: "110",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                var $index = ref.$index
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDelete(row, $index)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delText")))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2053690152
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "mt20 flex flex-spacebetween" }, [
                _c("span"),
                _c(
                  "div",
                  { staticClass: "font16", staticStyle: { color: "#3d3d3d" } },
                  [
                    _c("span", { staticClass: "mr20" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessPurchaseDetailPage.plantQtySum")
                        ) + "："
                      ),
                      _c("span", { staticClass: "font18" }, [
                        _vm._v(_vm._s(_vm.planQtyTotal || 0)),
                      ]),
                    ]),
                    _c("span", { staticClass: "mr20" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessPurchaseDetailPage.productVolume")
                        ) + "："
                      ),
                      _c("span", { staticClass: "font18" }, [
                        _vm._v(_vm._s(_vm.volumeTotal || 0) + " m³"),
                      ]),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessPurchaseDetailPage.cartonWeight")
                        ) + "："
                      ),
                      _c("span", { staticClass: "font18" }, [
                        _vm._v(_vm._s(_vm.weightTotal) + " kg"),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("ElementTableSortable", {
        ref: "ElementTableSortable",
        attrs: {
          "page-type": _vm.sortableSettingPage,
          "sortable-setting": _vm.sortableSetting,
        },
        on: { settingTableTitle: _vm.settingTableTitle },
      }),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: { multiple: "", config: _vm.$BjDialogListConfig.skuDefault() },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
      _c("ExcelImportDialog", {
        ref: "ExcelImport",
        attrs: { "template-type": _vm.computedTemplateType },
        on: { submit: _vm.getTableData },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }